import {Box, Stack} from "@mui/system";
import {Typography} from "@mui/material";
import { getStatusIcon } from '../eventFunctions';

const StatusLegend = ({ sx = {} }) => (
    <Stack direction="row" spacing={2} sx={{
      // marginTop: '16px',
      marginBottom: '16px',
      justifyContent: 'flex-end',
      ...sx,
    }}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            { getStatusIcon('CANCELED') }
            <Typography variant="body" sx={{ marginLeft: '4px' }}>
                Canceled
            </Typography>
        </Box>
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            { getStatusIcon('') }
            <Typography variant="body" sx={{ marginLeft: '4px' }}>
                Incomplete
            </Typography>
        </Box>
        <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            { getStatusIcon('COMPLETED') }
            <Typography variant="body" sx={{ marginLeft: '4px' }}>
                Completed
            </Typography>
        </Box>
    </Stack>
);
export default StatusLegend;
